import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _Search, _CloseCircle;
var _excluded = ["className"],
  _excluded2 = ["className"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className", "children", "colSpan"],
  _excluded6 = ["className", "isHeader"],
  _excluded7 = ["className"],
  _excluded8 = ["className"],
  _excluded9 = ["className"],
  _excluded0 = ["className"],
  _excluded1 = ["className"],
  _excluded10 = ["className", "count", "title"],
  _excluded11 = ["className", "debounceDelay", "value", "onChange", "onSearch"],
  _excluded12 = ["className"];
import * as React from 'react';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import Search from '@crehana/compass.icons.outline/Search';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Table = function Table(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-relative tw-w-full tw-overflow-auto tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700 tw-rounded tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01 dark:tw-text-neutral-light-100', className)
  }, props));
};
Table.displayName = 'Table';
export var TableContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx("div", {
    className: "tw-w-full tw-overflow-x-auto",
    children: /*#__PURE__*/_jsx("table", _objectSpread({
      ref: ref,
      className: cn('tw-w-full tw-caption-bottom tw-border-t tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700', className)
    }, props))
  });
});
TableContent.displayName = 'TableContent';
export var TableHeader = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx("thead", _objectSpread({
    ref: ref,
    className: cn('tw-border-b tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700 tw-h-4.4', className)
  }, props));
});
TableHeader.displayName = 'TableHeader';
export var TableBody = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx("tbody", _objectSpread({
    ref: ref,
    className: cn('[&_tr:last-child]:tw-border-0', className)
  }, props));
});
TableBody.displayName = 'TableBody';
export var TableFooter = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    children = _ref5.children,
    _ref5$colSpan = _ref5.colSpan,
    colSpan = _ref5$colSpan === void 0 ? 100 : _ref5$colSpan,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("tfoot", _objectSpread(_objectSpread({
    ref: ref,
    className: "tw-border-t tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700 [&>tr]:last:tw-border-b-0"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("td", {
        colSpan: 100,
        children: /*#__PURE__*/_jsx("div", {
          className: cn('tw-h-8.8 tw-flex tw-items-center tw-justify-center tw-w-full tw-relative', className),
          children: children
        })
      })
    })
  }));
});
TableFooter.displayName = 'TableFooter';
export var TableRow = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    isHeader = _ref6.isHeader,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsx("tr", _objectSpread({
    ref: ref,
    className: cn(isHeader ? 'tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-04' : 'tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-01 hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-700 data-[state=selected]:tw-bg-primary-light-100 dark:data-[state=selected]:tw-bg-neutral-dark-600', 'tw-transition-colors', 'tw-border-b tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-700', className)
  }, props));
});
TableRow.displayName = 'TableRow';
export var TableHead = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsx("th", _objectSpread({
    ref: ref,
    className: cn('tw-py-1 tw-px-2.4 tw-text-left tw-align-middle tw-font-link1 [&:has([role=checkbox])]:tw-pr-0 dark:tw-text-neutral-dark-400', className)
  }, props));
});
TableHead.displayName = 'TableHead';
export var TableCell = /*#__PURE__*/React.forwardRef(function (_ref8, ref) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsx("td", _objectSpread({
    ref: ref,
    className: cn('tw-px-2.4 tw-h-[7.2rem] tw-text-1.2 tw-font-body5 tw-align-middle [&:has([role=checkbox])]:tw-pr-0', className)
  }, props));
});
TableCell.displayName = 'TableCell';
export var TableCaption = /*#__PURE__*/React.forwardRef(function (_ref9, ref) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsx("caption", _objectSpread({
    ref: ref,
    className: cn('tw-mt-1.6 tw-text-sm tw-text-neutral-light-500 dark:tw-text-neutral-dark-400', className)
  }, props));
});
TableCaption.displayName = 'TableCaption';
export var TableTop = function TableTop(_ref0) {
  var className = _ref0.className,
    props = _objectWithoutProperties(_ref0, _excluded0);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-w-full tw-py-2 tw-px-2.4 tw-space-y-0.4', className)
  }, props));
};
TableTop.displayName = 'TableTop';
export var TableMainHeader = function TableMainHeader(_ref1) {
  var className = _ref1.className,
    props = _objectWithoutProperties(_ref1, _excluded1);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-w-full tw-flex tw-items-center tw-gap-2', className)
  }, props));
};
TableMainHeader.displayName = 'TableMainHeader';
export var TableTitleAndCounter = function TableTitleAndCounter(_ref10) {
  var className = _ref10.className,
    count = _ref10.count,
    title = _ref10.title,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-gap-0.8 tw-shrink-0",
    children: [/*#__PURE__*/_jsx("h3", _objectSpread(_objectSpread({
      className: cn('tw-font-subtitle5 dark:tw-text-neutral-light-100', className)
    }, props), {}, {
      children: title
    })), count >= 0 && /*#__PURE__*/_jsx("div", {
      className: "tw-font-link1 tw-px-0.8 tw-py-0.2 tw-rounded-0.4 tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-700 dark:tw-text-neutral-light-100",
      children: count
    })]
  });
};
TableTitleAndCounter.displayName = 'TableTitleWithCounter';
export var TableSearch = /*#__PURE__*/React.forwardRef(function (_ref11, ref) {
  var className = _ref11.className,
    _ref11$debounceDelay = _ref11.debounceDelay,
    debounceDelay = _ref11$debounceDelay === void 0 ? 300 : _ref11$debounceDelay,
    value = _ref11.value,
    _onChange = _ref11.onChange,
    onSearch = _ref11.onSearch,
    props = _objectWithoutProperties(_ref11, _excluded11);
  var _React$useState = React.useState(value !== null && value !== void 0 ? value : ''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchValue = _React$useState2[0],
    setSearchValue = _React$useState2[1];

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (value !== undefined && !onSearch && !_onChange) console.warn('Do not use value without onChange or onSearch function. The value will be uncontrolled.');
  var usedValue = value !== undefined && !onSearch ? value : searchValue;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  React.useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!onSearch) return;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (value === searchValue) return;
    var timer = setTimeout(function () {
      onSearch(searchValue);
    }, debounceDelay);
    return function () {
      return clearTimeout(timer);
    };
  }, [debounceDelay, value, searchValue]);
  var handleSearchClear = function handleSearchClear() {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (onSearch) onSearch('');
    setSearchValue('');
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-relative tw-flex tw-items-center",
    children: [/*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: cn('tw-input tw-max-w-28 tw-bg-neutral-light-200 dark:tw-bg-neutral-dark-700 dark:tw-border-neutral-dark-700 tw-pl-4.4 tw-pr-3.2', className),
      onChange: function onChange(e) {
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (_onChange) _onChange(e);
        setSearchValue(e.target.value);
      },
      value: usedValue
    }, props)), _Search || (_Search = /*#__PURE__*/_jsx(Search, {
      size: 24,
      className: "tw-absolute tw-left-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
    })), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: cn('tw-absolute tw-right-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500', usedValue.length === 0 && 'tw-hidden'),
      onClick: handleSearchClear,
      children: _CloseCircle || (_CloseCircle = /*#__PURE__*/_jsx(CloseCircle, {
        size: 16,
        className: "tw-text-inherit"
      }))
    })]
  });
});
TableSearch.displayName = 'TableSearch';
export var TableDescription = function TableDescription(_ref12) {
  var className = _ref12.className,
    props = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsx("p", _objectSpread({
    className: cn('tw-font-body4 tw-text-neutral-light-700 dark:tw-text-neutral-dark-400', className)
  }, props));
};
TableDescription.displayName = 'TableDescription';